module.exports = __webpack_public_path__ + "static/media/loc3_img20.38923616.jpg";